var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_789)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.587 15.588C3.19567 15.9793 3 16.45 3 17L3 20C3 20.55 3.19567 21.021 3.587 21.413C3.979 21.8043 4.45 22 5 22L9 22C9.55 22 10.021 21.8043 10.413 21.413C10.8043 21.021 11 20.55 11 20L11 17C11 16.45 10.8043 15.9793 10.413 15.588C10.021 15.196 9.55 15 9 15L8 15L8 13L16 13L16 15L15 15C14.45 15 13.9793 15.196 13.588 15.588C13.196 15.9793 13 16.45 13 17L13 20C13 20.55 13.196 21.021 13.588 21.413C13.9793 21.8043 14.45 22 15 22L19 22C19.55 22 20.021 21.8043 20.413 21.413C20.8043 21.021 21 20.55 21 20L21 17C21 16.45 20.8043 15.9793 20.413 15.588C20.021 15.196 19.55 15 19 15L18 15L18 11L16 11L8 11C7.45 11 6.979 11.196 6.587 11.588C6.19567 11.9793 6 12.45 6 13L6 15L5 15C4.45 15 3.979 15.196 3.587 15.588ZM15 20L15 17L19 17L19 20L15 20ZM5 20L5 17L9 17L9 20L5 20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9L11 11L13 11L13 9L14 9C14.55 9 15.021 8.804 15.413 8.412C15.8043 8.02067 16 7.55 16 7L16 4C16 3.45 15.8043 2.97933 15.413 2.588C15.021 2.196 14.55 2 14 2L10 2C9.45 2 8.97933 2.196 8.588 2.588C8.196 2.97933 8 3.45 8 4L8 7C8 7.55 8.196 8.02067 8.588 8.412C8.97933 8.804 9.45 9 10 9L11 9ZM10 7L10 4L14 4L14 7L10 7Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart-icon.0cb3ced9a5b67ce45cfd9efaa54ead13.svg";
export { ForwardRef as ReactComponent };